module.exports = __webpack_public_path__ + "img/tu-2.85bc7caa.png";